export default __webpack_public_path__ + "static/media/book_icon.477864c6.png";